import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App.tsx";
import { initParseServer } from "./Requests/ParseConfiguration";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Provider } from "mobx-react";
import { speakersStore } from "./Store/SpeakersStore";
import { newsStore } from "./Store/NewsStore";
import { partnershipsStore } from "./Store/PartnershipsStore";
import { eventsStore } from "./Store/EventsStore";
import { membersStore } from "./Store/MembersStore";
import { eventsCategoriesStore } from "./Store/EventCategoriesStore.ts";
import { guestsStore } from "./Store/GuestsStore.ts";


initParseServer()

const stores = [
  speakersStore,
  newsStore,
  partnershipsStore,
  eventsStore,
  membersStore,
  eventsCategoriesStore,
  guestsStore
]

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <HashRouter>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Provider {...stores}>
          <App />
        </Provider>
      </LocalizationProvider>
    </HashRouter>
  </React.StrictMode>
)
